import styled from 'styled-components'
import { respondTo } from '../_respondTo'

export const TextColorYellow = styled.span`
  color: #F7DF1E;
`

export const TitleSkill = styled.h3`
  color: #F7DF1E;
  font-size: 1.8rem;
  margin: 0;
`

export const ImgSkill = styled.img`
  height: 50px;
  margin: 6px;

  ${respondTo.lg`
  padding: 10px 15px;
  `}

  ${respondTo.xl`
  `}
`

export const TitleH3 = styled.h3`
  color: ${props => props.color || "#E0E4E4"};
  font-size: ${props => props.fontSize || "1.5rem"};
  margin: 0;
  margin-top: ${props => props.marginTop || "0px"};
  margin-bottom: ${props => props.marginBottom || "0px"};
  margin-right: ${props => props.marginRigth || "0px"};
  text-align: ${props => props.textAlign || 'justify'};
  text-transform: capitalize;
  
  ${respondTo.xs`

  `}

  ${respondTo.sm`
  `}

  ${respondTo.md`
  `}

  ${respondTo.lg`
    font-size: ${props => props.fontSize_lg || "1.5rem"};
    padding-bottom: ${props => props.paddingBottom_lg || "0px"};
  `}

  ${respondTo.xl`
  font-size: ${props => props.fontSize_xl || "3rem"};
  `}
`

export const FlexContainer = styled.div`
  display: flex;
  width: 100%;
  padding: ${props => props.padding || "0"};
  flex-direction: ${props => props.flexDirection || "row"};
  align-items: ${props => props.alignItems || "none"};
`
